import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
})
export class SignInComponent implements OnInit {
  credentials = {
    email: undefined,
    password: undefined,
  };
  @Output() close = new EventEmitter<void>();
  @Output() register = new EventEmitter<void>();

  constructor(
    private userService: UserService,
    public sharedService: SharedService
  ) {}

  ngOnInit(): void {}

  signIn(
    provider?: string,
    credentials?: { email: string; password: string }
  ): void {
    this.userService.signIn(provider, credentials).then(() => {
      this.close.emit();
    });
  }
}
